<template>
    <div class="ah-mini-switch" @click="onClick" :class="{ on: inputVal }">
        <div class="toggler">
            <div class="handle"></div>
        </div>
        <div class="name">{{ name }}</div>
    </div>
</template>
<script>
export default {
    props: {
        name: {
            type: String,
            default: () => {},
        },
        value: {
            type: Boolean,
            default: null,
        },
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
    methods: {
        onClick() {
            this.inputVal = !this.inputVal;
            this.$nextTick(() => {
                this.$emit('change', this.inputVal);
            });
        },
    },
};
</script>
<style lang="scss">
.ah-mini-switch {
    display: flex;
    padding: 2px 10px;
    border-radius: 4px;
    align-items: center;
    gap: 10px;

    > .toggler {
        position: relative;
        width: 20px;
        height: 10px;
        background-color: #ffffff55;
        border-radius: 10px;
        transition: 0.2s;
        cursor: pointer;

        > .handle {
            position: absolute;
            top: 2px;
            left: 2px;
            width: 6px;
            height: 6px;
            background-color: #fff;
            border-radius: 10px;
            transition: 0.2s;
        }
    }

    > .name {
        font-size: 9pt;
        opacity: 0.5;
        transition: 0.2s;
        cursor: pointer;
    }

    &:hover {
        > .name {
            opacity: 0.75;
        }
        > .toggler {
            background-color: #ffffff66;
        }
    }

    &.on {
        > .name {
            opacity: 1;
        }
        > .toggler {
            background-color: rgb(86, 197, 0);
            > .handle {
                left: 12px;
                background-color: #fff;
            }
        }
    }

    &.on:hover {
        > .toggler {
            background-color: rgb(86, 197, 0);
        }
    }
}
</style>
